<template>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Simply Investing Dividend Course</a>
            </li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Select a <strong>Stock Table</strong> below to explore stocks by <strong>Exchange</strong>,
                    and adjust the other settings as needed.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Course</h3>

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view
                            functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="grid -mt-3 -ml-3 -mr-3">

                        <div class="col-12 md:col-12 lg:col-12">

                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <span>
                                        <h4>Start here...</h4>
                                        <br/>
                                        <B>STEP 1</B>: Begin the Simply Investing Course by starting with Lesson 1 (see
                                        below), then continue with the remaining Lessons.
                                        <br/><br/>
                                        <B>STEP 2</B>: When viewing the Lessons you can turn the captions ON or OFF, and
                                        also view in full screen mode.
                                        <br/><br/>
                                        <B>STEP 3</B>: Links to the SI Reference Guide, SI Google Sheet, Portfolio
                                        Tracker, are provided below.
                                        <br/>
                                    </span>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #1: What will you learn?</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/ee29562c-b68a-4d2f-bac8-734aa4485ea2?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #2: My story</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/e95aed7f-3e25-4771-92cb-a5723cc4453d?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #3: Investing myths</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/52a1a17c-13ed-4f3c-ae5e-59d6233bd6a4?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #4: The basics</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/fb4054a2-1d0d-4ce6-81be-7a537e637386?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #5: Simply Investing Rules 1, 2, 3</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/3a4dc3d5-7f95-4ed6-8e3f-d9851d33a87e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #6: Simply Investing Rules 4, 5, 6</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/d68c31c5-70e6-47f0-b471-6ae01a7f3ed0?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">

                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>


                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #7: Simply Investing Rules 7, 8, 9</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/e82f3103-58cd-4479-9ab5-81c5f6c88db6?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #8: Simply Investing Rules 10, 11, 12</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/d2272383-950b-45db-9ec7-ee0af5ebc22c?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #9: DIY vs DIY with Help</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/7b3b96e7-022c-4716-9852-eb1735ba58af?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #10: Option A, Do-it-Yourself Method</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/35a1b545-6a12-410c-9f81-391570a753f0?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #11: Option A, Final Steps</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/0eaf0144-037c-4f55-ad14-1457ca6f8b36?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #12: Option B, DIY with Help</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/bba98918-ecbe-4576-bb6e-5e6a0ed78cbe?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #13: Using the SI Web Application</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/ab065eee-1acb-4a6d-bb92-b6aabc4071b8?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #14: Using a discount broker</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/26fa7c99-1692-42a4-97c4-897dc91742f8?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #15: US trading accounts</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/65320a30-22f1-4c7d-9306-598fd31d879a?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #16: Canadian trading accounts</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/616bb2f0-5953-4ce8-b831-a15510153319?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #17: Placing your first stock order</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/8decb6f3-73ab-4632-b89c-6b83735b53de?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #18: Building your portfolio</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/9f71846b-d0c0-4948-ae4f-e22764de66dd?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #19: Tracking your portfolio</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/119108b8-2ef5-4be9-81b9-7e0e7cd4d3d2?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #20: When should you sell?</h3>

                                    <div style="position:relative;padding-top:56.25%;">

                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/88f47a40-e2eb-4b81-9d7c-2562925cbd57?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #21: Guidelines for selling</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/ee828008-0a9d-4d2d-833c-bbe6bf71e06c?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #22: Why Mutual Funds Fail</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/27b6632a-5a34-4a0a-95e6-5c31be5128d6?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #23: What about Index Funds & ETFs?</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/70018c08-c4bc-433f-b22c-b34a3873b14e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #24: Managing your risk</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/74b0ff4d-33c2-46a8-af57-3fcfcb6b4e5e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #25: Investing myths revisited</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/bd93e367-b5c0-47d4-803d-38a9cad8a814?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #26: Getting started right away</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/7aa2c32c-70be-49dc-a2a4-93fdc2906ee6?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Lesson #27: Your frequently asked questions</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/35b0c1b0-f132-426a-acb5-e9900c75e30f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true"></iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Bonus Video #1: Where to obtain a list of US/CAD stocks</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/a4e35574-a8f6-45aa-ae3c-67b974ce3c19?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Bonus Video #2: Completing the SI Spreadsheet for US/CAD stocks</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/4f99fdf8-26a5-4952-b92b-7c21ea255932?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Bonus Video #3: Where to obtain a list of UK stocks</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/9f8dee23-888c-4717-921a-775169c07173?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Bonus Video #4: Completing the SI Spreadsheet for UK stocks</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/182315db-a980-46e1-b477-733d2ed2d5be?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-6 lg:col-4">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Bonus Video #5: Stock splits explained</h3>

                                    <div style="position:relative;padding-top:56.25%;">
                                        <iframe
                                            src="https://iframe.mediadelivery.net/embed/568283/178c4c32-f918-414e-8c25-8f511e345e4f?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
                                            loading="lazy"
                                            style="border:0;position:absolute;top:0;height:100%;width:100%;"
                                            allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                                            allowfullscreen="true">
                                        </iframe>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="grid -mt-3 -ml-3 -mr-3">

                        <div class="col-12 md:col-12 lg:col-12">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Download Reference Guide</h3>

                                    <a href="https://simplyinvesting.com/si-reference-guide"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       class="p-button p-component">
                                        <span class="p-button-label">Download Reference Guide</span>
                                    </a>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-12 lg:col-12">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Download Stock Analysis Google Sheet</h3>

                                    <a href="https://docs.google.com/spreadsheets/d/16GjqXgJ8RpQCaNhOY5pEPAdonSUvpR0QRMHUQiDXprQ/copy?usp=sharing"
                                       target="_blank" rel="noopener noreferrer" class="p-button p-component">
                                        <span class="p-button-label">Download Stock Analysis Google Sheet</span>
                                    </a>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-12 lg:col-12">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <h3>Download Portfolio Tracker Google Sheet</h3>

                                    <a href="https://docs.google.com/spreadsheets/d/1-iK41aAMFGqwHGcQfFlkFfJBGgh320fBL6LXR_Zlpfw/copy?usp=sharing"
                                       target="_blank" rel="noopener noreferrer" class="p-button p-component">
                                        <span class="p-button-label">Download Portfolio Tracker Google Sheet</span>
                                    </a>

                                </div>
                            </div>
                        </div>

                        <div class="col-12 md:col-12 lg:col-12">
                            <div class="p-2">
                                <div class="shadow-2 p-4 surface-card border-round">

                                    <div class="font-medium text-900 mt-4 mb-3">
                                        <a @click="processFaq" class="text-primary hover:underline" role="button"
                                           style="cursor: pointer;">Frequently Asked Questions</a>

                                        <br/><br/>
                                        Note: A Google account is required to download the Google Sheets.

                                        <br/><br/>
                                        More Questions?

                                        <a @click="processEmail" class="text-primary hover:underline" role="button"
                                           style="cursor: pointer;">Send us an email</a>

                                        or post a message on the member's only
                                        <a @click="processLinkedInGroup" class="text-primary hover:underline"
                                           role="button" style="cursor: pointer;">LinkedIn Group.</a>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[Applications][mounted] Data = ", userData);
            console.log("[Applications][mounted] this.profile = ", this.profile);

            if (this.profile.rights === 'G') {
                this.activeTab = 1;
            } else {
                this.activeTab = 2;
            }

        } catch (e) {
            console.error("[Applications][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[Applications][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[Applications][mounted] Could not find user config for user = ", this.userStore.user.id);
            this.userConfiguration = {
                enableAppstoreApp1: 'N',
                enableAppstoreApp2: 'N',
                enableAppstoreApp3: 'N',
                enableAppstoreApp4: 'N',
                enableAppstoreApp5: 'N',
                enableAppstoreApp6: 'N',
                enableAppstoreApp7: 'N',
                enableAppstoreApp8: 'N',
                enableAppstoreApp9: 'N',
                enableAppstoreApp10: 'N'
            };

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            userConfiguration: {},
        }
    },
    methods: {
        callOverview() {
            this.$router.push("siOverview");
        },
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processFaq() {
            console.log("[Course][processFaq] Beginning.");
            window.open("https://www.simplyinvesting.com/course-faq", '_blank');
        },
        processEmail() {
            console.log("[Course][processEmail] Beginning.");
            window.open("https://www.simplyinvesting.com/contact", '_blank');
        },
        processLinkedInGroup() {
            console.log("[Course][processLinkedInGroup] Beginning.");
            window.open("https://www.linkedin.com/groups/14562007", '_blank');
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
